<template>
  <div class="flex flex-column justify-center box">
      <nav-header></nav-header>
      <nav-menu></nav-menu>
      <router-view />
      <footer-box></footer-box>
  </div>
</template>

<script>
import Header from '@/components/front/header/Header'
import Menu from '@/components/front/menu/Menu'
import Footer from '@/components/front/footer/Footer'
export default {
    components:{
        [Header.name]: Header,
        [Menu.name]: Menu,
        [Footer.name]: Footer
    }
}
</script>

<style lang="scss" scoped>
.box{
    padding-bottom: 130px;
    width: 100%;
    height: auto;
    position: relative;
}
</style>


// WEBPACK FOOTER //
// src/front/index/Index.vue